export default {
  form: {
    display_name: {
      label: 'Nome do restaurante',
      placeholder: 'Introduza o nome do restaurante',
      help: 'Utilizado no seu contrato e faturas',
    },
    store_address: {
      label: 'Morada da loja',
      placeholder: 'Procure a sua morada',
      help: 'Esta é a morada que os seus clientes veem',
    },
    address: {
      label: 'Morada',
      placeholder: 'Rua + número',
    },
    zip_code: {
      label: 'Código postal',
      placeholder: 'Código postal',
    },
    city: {
      label: 'Cidade',
      placeholder: 'Cidade',
    },
    state: {
      label: 'Distrito',
      placeholder: 'Selecione o distrito',
    },
    country: {
      label: 'País',
      help: 'Para mudar o seu restaurante para outro país, contacte o suporte',
    },
  },
  staff_notice:
    'O pessoal da loja não pode confirmar o nome e a morada do restaurante. Peça ao seu gestor de integração para verificar estes dados.',
  toasts: {
    saved: 'Detalhes da loja guardados',
    error: 'Não foi possível guardar os detalhes da sua loja',
  },
  buttons: {
    next: 'Seguinte',
  },
};
